module.exports = __webpack_public_path__ + "img/deepseek.8c727cc7.png";